import { isEqual } from "lodash";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import {
  filterCriteriaSF,
  isEntityServerSideFiltered,
  isEntityServerSidePaginated,
  lastSearchCriteriaAtomFamily,
  resolveSelected,
  selectedTableRowsIdsAtomFamily,
  selectedTableRowsIdsSetSF,
  tableSelectionScopeRowsIdsSF,
} from "@ryde/shared";

import { usePageContext } from "../../contexts";
import { useSelectedIds } from "../use-selected-ids";

export const useWatchingSelectedIds = (): void => {
  const { entity } = usePageContext();
  const typeOrmCriteriaObj = useRecoilValue(filterCriteriaSF(entity));
  const { clearSelectedIds } = useSelectedIds();
  const [lastSearchCriteria, setLastSearchCriteria] = useRecoilState(
    lastSearchCriteriaAtomFamily(entity),
  );

  const selectionScopeRowsIds = useRecoilValue(
    tableSelectionScopeRowsIdsSF(entity),
  );
  const setSelectedTableRowsIds = useSetRecoilState(
    selectedTableRowsIdsAtomFamily(entity),
  );
  const selectedTableRowsIdsSet = useRecoilValue(
    selectedTableRowsIdsSetSF(entity),
  );

  useEffect(() => {
    if (isEntityServerSideFiltered(entity)) {
      return;
    }

    if (!isEqual(lastSearchCriteria, typeOrmCriteriaObj)) {
      // clearSelectedIds();
    }

    setLastSearchCriteria(typeOrmCriteriaObj);
  }, [
    clearSelectedIds,
    entity,
    lastSearchCriteria,
    setLastSearchCriteria,
    typeOrmCriteriaObj,
  ]);

  useEffect(() => {
    if (isEntityServerSidePaginated(entity)) {
      return;
    }

    resolveSelected({
      selectedTableRowsIds: selectedTableRowsIdsSet,
      setSelectedTableRowsIds,
      tableIds: selectionScopeRowsIds,
    });
    // We want an effect only on ids grid ids changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionScopeRowsIds]);
};
